import FaqBody from './FaqBody';
import type { FaqData } from './FaqBody';

const FaqView = ({ data }: { data: FaqData }) => <FaqBody data={data} />;

export default FaqView;
